// extracted by mini-css-extract-plugin
export default {"select":"styles_select__T6ZPH","withValue":"styles_withValue__1o3if","inline":"styles_inline__+IAtD"};